import { render, staticRenderFns } from "./TechnicianIndex.vue?vue&type=template&id=81b98cea"
import script from "./TechnicianIndex.vue?vue&type=script&lang=ts"
export * from "./TechnicianIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports